'use client';

import { THeroIcon } from '../../types';

import {
  DropdownDescriptionTw,
  DropdownDividerTw,
  DropdownItemTw,
  DropdownLabelTw,
} from '../dropdown';

export interface IDropdownOption<T> {
  description?: string;
  IconActive?: THeroIcon;
  IconBefore?: THeroIcon;
  id: T;
  label: string;
}

interface IRenderDropDownItem<T> {
  hasDividerAfter?: boolean;
  isDescriptionEnabled?: boolean;
  isIconEnabled?: boolean;
  item: IDropdownOption<T>;
  onClickItem: (item: IDropdownOption<T>) => void;
}

export function RenderDropDownItem<T>({
  isDescriptionEnabled = true,
  isIconEnabled = true,
  hasDividerAfter,
  item,
  onClickItem,
}: IRenderDropDownItem<T>) {
  const { description, IconBefore, label } = item;

  const handleOnClick = () => {
    onClickItem(item);
  };

  return (
    <>
      <DropdownItemTw className="active current" onClick={handleOnClick}>
        {isIconEnabled && IconBefore ? <IconBefore /> : null}

        <DropdownLabelTw>{label}</DropdownLabelTw>

        {isDescriptionEnabled && description ? (
          <DropdownDescriptionTw>{description}</DropdownDescriptionTw>
        ) : null}
      </DropdownItemTw>

      {hasDividerAfter ? <DropdownDividerTw /> : null}
    </>
  );
}
